/*
    This file has to be imported so all component registrations can take place
*/
import {
    Icon,
    Illustration,
    SpinnerBars,
    SpinnerContainer,
    CustomImage,
    Button,
    MaintenanceChecker,
    SdsTabItem,
} from '@superbet-group/web.lib.ui-components';
import Vue from 'vue';

import SplitInput from './forms/SplitInput.vue';
import SubtleLink from './SubtleLink.vue';
import PrivacyConsentWithdrawalInfo from './PrivacyConsentWithdrawalInfo.vue';
import SuperBetsDetails from '@modules/eventGrid/components/markets/superBets/SuperBetsDetails.vue';
import Pick from '@modules/shared/event/Pick.vue';
import CustomRouterLink from '@shared/components/router/CustomRouterLink.vue';
import TicketSelectionCard from '@sportOfferFederation/ticketSelection/TicketSelectionCard.vue';
import { getFederationComponent } from '@src/federations/getFederationComponent';
import QuickDepositButton from '@walletFederation/src/modules/quickDeposit/QuickDepositButton.vue';
import GenericForm from './forms/GenericForm.vue';

// @TODO: These will be migrated to web.lib-ui-components sometimes later
import SdsPageHeader from './pageHeader/SdsPageHeader.vue';

import SdsTabs from './tabs/SdsTabs.vue';

import SdsBreadcrumbs from './breadcrumbs/SdsBreadcrumbs.vue';
import SdsBreadcrumbsItem from './breadcrumbs/SdsBreadcrumbItem.vue';
import HomePageHeader from '@modules/home/HomePageHeader.vue';
import SuperBetsWidget from '@modules/news/components/SuperBetsWidget.vue';
import PriceBoostOddValue from '@src/federations/sportOffer/price-boost/components/PriceBoostOddValue.vue';
import SuperBonusBadge from '@modules/shared/betSlip/SuperBonus/SuperBonusBadge.vue';
import UseSportRoute from '@src/app/shared/modules/sportOffer/components/UseSportRoute.vue';
import StaticLink from './StaticLink.vue';
import CustomTemplateSelect from './forms/CustomTemplateSelect.vue';
import CustomInput from './forms/CustomInput.vue';
import CustomCheckbox from './forms/CustomCheckbox.vue';
import TermsAndConditions from './TermsAndConditions.vue';
import Barcode from './Barcode.vue';

export function registerGlobalComponents() {
    /**
     * Remove registering UsingXJackpotDetails globally once gaming is federated.
     * Then, all other federations can import this component directly from gaming federation.
     */
    Vue.component('UsingXJackpotDetails', getFederationComponent(() => import('gaming/UsingXJackpotDetails')));
    Vue.component('SplitInput', SplitInput);
    Vue.component('CustomImage', CustomImage);
    Vue.component('SpinnerBars', SpinnerBars);
    Vue.component('SpinnerContainer', SpinnerContainer);
    Vue.component('Illustration', Illustration);
    Vue.component('Icon', Icon);
    Vue.component('CustomButton', Button);
    Vue.component('MaintenanceChecker', MaintenanceChecker);
    Vue.component('CustomRouterLink', CustomRouterLink);
    Vue.component('SubtleLink', SubtleLink);
    Vue.component('PrivacyConsentWithdrawalInfo', PrivacyConsentWithdrawalInfo);
    Vue.component('QuickDepositButton', QuickDepositButton);

    // TODO: Remove and notify Post-Bet Placement when federating
    Vue.component('Pick', Pick);
    Vue.component('SuperBetsDetails', SuperBetsDetails);
    Vue.component('TicketSelection', TicketSelectionCard);
    Vue.component('PriceBoostOddValue', PriceBoostOddValue);
    Vue.component('SuperBonusBadge', SuperBonusBadge);
    Vue.component('Barcode', Barcode);

    Vue.component('SdsPageHeader', SdsPageHeader);
    Vue.component('SdsTabs', SdsTabs);
    Vue.component('SdsTabItem', SdsTabItem);
    Vue.component('SdsBreadcrumbs', SdsBreadcrumbs);
    Vue.component('SdsBreadcrumbsItem', SdsBreadcrumbsItem);

    Vue.component('MatchWidget', () => import('@modules/news/components/MatchWidget.vue'));
    Vue.component('MarketWidget', () => import('@modules/news/components/MarketWidget.vue'));
    Vue.component('SuperBetsWidget', SuperBetsWidget);

    // Defining here to use in social
    Vue.component('HomePageHeader', HomePageHeader);
    Vue.component('UseSportRoute', UseSportRoute);

    // Used in account Federation
    Vue.component('GenericForm', GenericForm);
    Vue.component('StaticLink', StaticLink);
    Vue.component('CustomTemplateSelect', CustomTemplateSelect);
    Vue.component('CustomInput', CustomInput);
    Vue.component('CustomCheckbox', CustomCheckbox);
    Vue.component('TermsAndConditions', TermsAndConditions);
}
